import { getProductsScoresApiV1StatsOrgIdProductsScoresGet } from '@/common/api/client/sdk.gen'
import type { ValidateProductScoresSchema } from '@/common/api/client/types.gen'
import type { CompanyStatsProductsScoresQueryParams } from '../model'

const DEFAULT_PAGE_SIZE = 50

export const fetchAllCompanyStatsProductsScores = async (
    orgId: string,
    params: Omit<CompanyStatsProductsScoresQueryParams, 'page' | 'size'> & { pageSize?: number }
): Promise<ValidateProductScoresSchema[]> => {
    const { pageSize: requestedPageSize, ...query } = params
    const pageSize = requestedPageSize ?? DEFAULT_PAGE_SIZE

    const firstResponse = await getProductsScoresApiV1StatsOrgIdProductsScoresGet({
        path: { org_id: orgId },
        query: {
            page: 1,
            size: pageSize,
            order_by: query.order_by,
            direction: query.direction,
            target: query.target ?? null,
            brand: query.brand ?? null,
            seller: query.seller ?? null,
        },
    })

    const firstPage = firstResponse.data
    if (!firstPage) return []

    const allItems = [...firstPage.items]
    const totalPages = firstPage.pages ?? 1

    for (let page = 2; page <= totalPages; page += 1) {
        const response = await getProductsScoresApiV1StatsOrgIdProductsScoresGet({
            path: { org_id: orgId },
            query: {
                page,
                size: pageSize,
                order_by: query.order_by,
                direction: query.direction,
                target: query.target ?? null,
                brand: query.brand ?? null,
                seller: query.seller ?? null,
            },
        })
        allItems.push(...(response.data?.items ?? []))
    }

    return allItems
}
